import { ActiveDataListColumnFilterEntry, BulkRequest, Id } from "@dgs/core";
import { TenantOptionResource } from "../../../../shared/types/tenant";
import { AddressIndexResource, AddressUpdateResource } from "./address";
import { IInvitationListAttachSingleContactRequest } from "./invitationList";
import { TagOptionResource } from "./tag";

export type ICompanyIndexResource = {
	id: Id;
	name: string;
	parent: ICompanyOptionResource | null;
	tenants: TenantOptionResource[];
	tags: TagOptionResource[];
	primaryAddress: AddressIndexResource | null;
	eventPriority: string | null;
	carFleetStatus: CarFleetStatus;
};

export type ICompanyOptionResource = {
	id: Id;
	name: string;
	primaryAddress: AddressIndexResource | null;
};

export type CompanyTenantPivotValue = {
	eventPriority: string | null;
	carFleetStatus: CarFleetStatus;
};

export type ICompanyUpdateResource = {
	id: Id;
	name: string;
	parent: ICompanyOptionResource | null;
	tenants: TenantOptionResource[];
	tags: TagOptionResource[];
	primaryAddress: AddressIndexResource | null;
	addresses: AddressUpdateResource[];
	isArchived: boolean;
	archivedByTenants: TenantOptionResource[];
	pivotValues: Record<string, CompanyTenantPivotValue>;
};

export type ICompanyFormState = {
	name: string;
	parent: ICompanyOptionResource | null;
	tenants: TenantOptionResource[];
	pivotValues: Record<string, CompanyTenantPivotValue>;
};

export type ICompanyRequest = Omit<ICompanyFormState, "parent" | "tenants"> & {
	parentId: Id | null;
};

export interface ICompanyContact {
	id: Id;
	firstName: string;
	lastName: string;
	position: string;
}

export type CompanyCreateMasterDataRequest = ICompanyRequest;

export interface CompanyCreateAddressRequest {
	city: string;
	zip: string;
	houseNumber: string;
	street: string;
	additionalInfo: string;
	countryId: Id;
	isPrimary: boolean;
}

export type CompanyCreateTagRequest = Id;

export interface CompanyCreateRequest {
	masterData: CompanyCreateMasterDataRequest;
	addresses: CompanyCreateAddressRequest[];
	tagIds: CompanyCreateTagRequest[];
}

export enum CarFleetStatus {
	ACTIVE = "Active",
	Passive = "Passive",
	NOT_RELEVANT = "Not relevant",
}

export interface CompaniesBulkAttachRequest extends BulkRequest, IInvitationListAttachSingleContactRequest {
	eventId: Id;
	filters: ActiveDataListColumnFilterEntry<ICompanyIndexResource, unknown, unknown>[];
}
